import { COMPONENT_STATES, COMPONENT_TYPE, DEFAULT_MEDIA_QUERY_PLATFORMS } from 'common/constants';
import { UNIFORM_PROPS } from 'common/constants/component-props';
import { ShareType } from './constants';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock, CreationContextFor } from '../creation-types';

export const share = ({
	dictionary,
}: CreationContextFor<typeof COMPONENT_TYPE.SHARE>): CreatedBuildingBlock<typeof COMPONENT_TYPE.SHARE> =>
	createModel({
		type: COMPONENT_TYPE.SHARE,
		componentProps: {
			[UNIFORM_PROPS.shareType]: ShareType.fb,
			styles: {
				[COMPONENT_STATES.DEFAULT]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {},
				},
				[COMPONENT_STATES.HOVER]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
						opacity: 0.7,
					},
				},
			},
			other: {},
		},
		children: {
			[COMPONENT_STATES.DEFAULT]: {
				[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: dictionary.SHARE.text,
			},
		},
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.SHARE>;
